export const FLAG_GETTING_BANK_RECONCILIATIONS =
  'FLAG_GETTING_BANK_RECONCILIATIONS';
export const GET_BANK_RECONCILIATIONS = 'GET_BANK_RECONCILIATIONS';
export const CLEAR_BANK_RECONCILIATIONS = 'CLEAR_BANK_RECONCILIATIONS';

export const FLAG_GETTING_BANK_RECONCILIATION_LIQUIDATIONS =
  'FLAG_GETTING_BANK_RECONCILIATION_LIQUIDATIONS';
export const GET_BANK_RECONCILIATION_LIQUIDATIONS =
  'GET_BANK_RECONCILIATION_LIQUIDATIONS';
export const CLEAR_BANK_RECONCILIATION_LIQUIDATIONS =
  'CLEAR_BANK_RECONCILIATION_LIQUIDATIONS';

export const FLAG_GETTING_BANK_RECONCILIATION_DEPOSITS =
  'FLAG_GETTING_BANK_RECONCILIATION_DEPOSITS';
export const GET_BANK_RECONCILIATION_DEPOSITS =
  'GET_BANK_RECONCILIATION_DEPOSITS';
export const CLEAR_BANK_RECONCILIATION_DEPOSITS =
  'CLEAR_BANK_RECONCILIATION_DEPOSITS';

export const FLAG_GETTING_BANK_RECONCILIATION_BANK_SUMMARY =
  'FLAG_GETTING_BANK_RECONCILIATION_BANK_SUMMARY';
export const GET_BANK_RECONCILIATION_BANK_SUMMARY =
  'GET_BANK_RECONCILIATION_BANK_SUMMARY';
export const CLEAR_BANK_RECONCILIATION_BANK_SUMMARY =
  'CLEAR_BANK_RECONCILIATION_BANK_SUMMARY';

export const FLAG_GETTING_BANK_RECONCILIATION_CORPORATES =
  'FLAG_GETTING_BANK_RECONCILIATION_CORPORATES';
export const GET_BANK_RECONCILIATION_CORPORATES =
  'GET_BANK_RECONCILIATION_CORPORATES';
export const CLEAR_BANK_RECONCILIATION_CORPORATES =
  'CLEAR_BANK_RECONCILIATION_CORPORATES';

export const FLAG_GETTING_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS =
  'FLAG_GETTING_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS';
export const GET_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS =
  'GET_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS';
export const CLEAR_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS =
  'CLEAR_BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHERS';

export const FLAG_GETTING_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS =
  'FLAG_GETTING_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS';
export const GET_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS =
  'GET_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS';
export const CLEAR_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS =
  'CLEAR_BANK_RECONCILIATION_MANUAL_VOUCHER_PAYMENTS';
